import { createReducer } from '@reduxjs/toolkit'

import * as keyMetricActions from '../../actions/KeyMetrics/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

import { TKeyMetricApi } from 'types/GlobalKeyMetric'
import { TResourceVariant } from 'types/GlobalResource'

export type ResourceEntry = {
  id: string
  type: TResourceVariant
}

export interface ResourceKeyMetricLinkerState {
  byKeyMetricId: Record<string, ResourceEntry[]>
}

const INITIAL_STATE: ResourceKeyMetricLinkerState = {
  byKeyMetricId: {}
}

function buildFromKeyMetrics(
  keyMetrics: TKeyMetricApi[]
): ResourceKeyMetricLinkerState {
  const byKeyMetricId: Record<string, ResourceEntry[]> = {}

  const processKeyMetric = (km: TKeyMetricApi) => {
    byKeyMetricId[km.id] =
      km.resources?.map((r) => ({
        id: r.resource_id,
        type: r.resource_type
      })) || []
    km.children?.forEach(processKeyMetric)
  }

  keyMetrics.forEach(processKeyMetric)

  return { byKeyMetricId }
}

const resourceKeyMetricLinkerReducer = createReducer(
  INITIAL_STATE,
  (builder) => {
    builder
      // key metrics fetched
      .addCase(keyMetricActions.getAllSuccess, (_, action) => {
        return buildFromKeyMetrics(action.payload)
      })

      // key metric updated
      .addCase(keyMetricActions.updateSuccess, (state, action) => {
        state.byKeyMetricId[action.payload.id] =
          action.payload.resources?.map((r) => ({
            id: r.resource_id,
            type: r.resource_type
          })) || []
      })

      // key metrics order updated (full re-fetch)
      .addCase(keyMetricActions.updateOrderSuccess, (_, action) => {
        return buildFromKeyMetrics(action.payload)
      })

      // pin actions (full re-fetch)
      .addCase(keyMetricActions.pinSuccess, (_, action) => {
        return buildFromKeyMetrics(action.payload)
      })

      // sign out
      .addCase(authenticationActions.signOut, () => INITIAL_STATE)
      .addDefaultCase((state) => state)
  }
)

export default resourceKeyMetricLinkerReducer
